import React, { memo, useEffect } from 'react'

import PolyCountContent, { QUICK_SELECTIONS } from 'Pods/SearchPage/Shared/PolyCountContent/PolyCountContent'
import useTranslate from 'Pods/SearchPage/Shared/useTranslate'
import { clearPolygon } from 'Pods/SearchPage/Store/actions/polygon'
import { useSearchPageStore } from 'Pods/SearchPage/Store/index'
import FiltersWrapper from 'Pods/Shared/FiltersWrapper/FiltersWrapper'

function PolyCount() {
  const t = useTranslate()

  const polygonRanges = useSearchPageStore(state => state.polygonRanges)
  const minPolygon = useSearchPageStore(state => state.minPolygon)
  const maxPolygon = useSearchPageStore(state => state.maxPolygon)

  // PolyCount only mounts when assetType === THREE_D_ONLY (see SecondaryFilters),
  // so unmount means the user switched to a different asset type - drop the
  // polygon selection so it does not silently carry over.
  useEffect(() => () => clearPolygon(), [])

  const isCustomRangeActive = minPolygon !== undefined || maxPolygon !== undefined
  const selectionCount = polygonRanges.length + (isCustomRangeActive ? 1 : 0)
  const hasSelectedAnyFilters = selectionCount > 0
  const placeholder = hasSelectedAnyFilters
    ? t('search_page.filters.poly_count.title_with_count', { count: selectionCount })
    : t('search_page.filters.poly_count.title')
  // Presets and the custom range are mutually exclusive, so the preset count is the widest label.
  const reservedPlaceholder = t('search_page.filters.poly_count.title_with_count', {
    count: QUICK_SELECTIONS.length,
  })

  return (
    <FiltersWrapper
      trailIconSize="small"
      placeholder={placeholder}
      reservedPlaceholder={reservedPlaceholder}
      content={<PolyCountContent />}
      hasSelectedAnyFilters={hasSelectedAnyFilters}
      closingDropdownClassName="filter-wrapper"
    />
  )
}

export default memo(PolyCount)
